import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import DobCom from '@/components/profile/dobCom'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/basicDetails/constants"

import '@/pages/profile/sections/common.css'

export default function Dob(props: any) {
    const { profile } = useLocalTranslation();

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <p className='commonH2'>
                {profile.fields.dateOfBirth}
                <span className='text-[#FF2828]'>*</span>
            </p>
            <p className='commonH3'>
                {profile.basicDetailsSection.notes.n5}
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }


            <DobCom
                onChange={(e: any) => props.handleInputChange(e, listOfSections.dob)}
                value={props.value}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.dob)}
                />
            </div>
        </div>
    );
}
